import UploadImageService from '@/services/api/uploadAdapter.service.js'

class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          this._requestUploadAPI(resolve, reject, file)
        })
    )
  }

  _requestUploadAPI(resolve, reject, file) {
    const data = new FormData()
    data.append('upload', file)
    const genericErrorText = `ไม่สามารถ Upload รูปนี้ได้: ${file.name}`

    UploadImageService
      .uploadImage(data)
      .then((res) => {
        resolve({
          default: res.data.url,
        })
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log('Error: ', err)
        reject(genericErrorText)
      })
  }
}

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader)
  }
}

export default MyCustomUploadAdapterPlugin
